import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {isMysterySymbol} from "../reels/symbols/MysterySymbol";
import {SymbolUtils} from "../utils/SymbolUtils";
import {DasUBootStatics} from "../utils/DasUBootStatics";
import {ClientXWays} from "../server/DasUBootData";
import {DasUBootGameMode} from "../server/DasUBootGameMode";

/**
 * Created by jonas on 2021-03-10.
 */

export class AvalancheXWays implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        const revealAnimations = []

        for (let data of DasUBoot.model.clientData.xWays) {
            let xWayIndex = 0;
            const xWayCount = DasUBootStatics.defaultGameAreaSize[data.reel] - 1 + data.size;
            const symbolScale = DasUBootStatics.defaultGameAreaSize[data.reel] / xWayCount;
            const reelTl = gsap.timeline();
            let partSize = DasUBootStatics.symbolHeight * symbolScale;

            const symbolDatas = DasUBoot.reelView.reels[data.reel].model.getAllVisibleSymbols();

            for (let i:number = 0; i < symbolDatas.length; i++) {
                const symbolData = symbolDatas[i];
                const symbol = <DasUBootSymbol>symbolData.positionable;


                let offset = (partSize * xWayIndex) - 144 * i;

                symbol.resetSymbolPosition(symbolData.reelPosition, offset);

                if (isMysterySymbol(symbol)) {
                    if (!symbol.isRevealed) {
                        symbol.addSubSymbols(SymbolUtils.createSubSymbols(data.reel, data.size, data.symbol));
                    }
                    if (this.shouldRevealDirectly(data)) {
                        revealAnimations.push(symbol.getStateAnimation(DasUBootSymbolStates.REVEAL));
                    }
                    reelTl.add(symbol.resize(symbolScale * data.size, offset, 0.5), 0);
                    xWayIndex += data.size;
                } else {
                    reelTl.add(symbol.resize(symbolScale, offset, 0.5), 0);
                    xWayIndex++;
                }
            }
            tl.add(reelTl, 0);

        }

        tl.add(revealAnimations);

    }

    shouldRun():boolean {
        return DasUBoot.model.clientData.xWays.length > 0;
    }


    private shouldRevealDirectly(data:ClientXWays) {
        return DasUBoot.model.data.mode == DasUBootGameMode.FREESPIN && data.reel == 1;
    }
}